import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '@shared/services/auth.service'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss'],
})
export class PublicFooterComponent implements OnInit, OnDestroy {
  isLoggedIn: boolean
  subscriptions: Subscription[] = []
  constructor(private authService: AuthService) {}
  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.userLoggedinEvent.subscribe(isLoggedIn => {
        this.isLoggedIn = isLoggedIn
      })
    )

    this.isLoggedIn = this.authService.isLoggedIn()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe())
  }
}
